/** Inputs of {@link hasSamePicks}. */
interface Params {
  /** The picks made while a filter was open. */
  picks: readonly string[];
  /** The picks the filter has applied. */
  applied: readonly string[];
}

/** Whether a filter's picks hold the same values as the applied ones, whatever their order. */
export const hasSamePicks = ({ picks, applied }: Params) => {
  const sortedPicks = [...picks].sort();
  const sortedApplied = [...applied].sort();
  const hasSameCount = sortedPicks.length === sortedApplied.length;

  return hasSameCount && sortedPicks.every((pick, index) => pick === sortedApplied[index]);
};
